import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=b3b099a4&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports